module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/heavyTank.b6228f13.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/heavyTank.png
// module id = 2720
// module chunks = 11